import React, { useState, useEffect } from "react";
import UserNavbar from "../UserNavbar";
import UserFooter from "../UserFooter";
import MainSidebar from "../Mainsidebar";
import "../../Style/Journal.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { path_url } from "../../Config/config";
import JournalConfiguration from "./JournalConfiguration";
const Configure = () => {
  // State to store toggle values for each label
  //  const [isPopupVisible, setIsPopupVisible] = useState(true);
  const [status, setStatus] = useState("");
  const [hamburger, sethamburger] = useState(false);
  const [isRightMenu, setisRightMenu] = useState(true);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);
  const navigate = useNavigate();
  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };
  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };
  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);
  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800)
      return { width: "100%", left: "0rem" };
    else
      return {
        width: !hamburger && "-webkit-fill-available",
        left: !hamburger && "3.7rem",
      };
  };
  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      const set = localStorage.getItem("status");
      if (set) {
        setStatus(set);
      } else {
        console.warn(
          "'status' not found in localStorage. Setting default value.",
        );
        setStatus("default_status_value");
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <div className="con1 d-flex">
        <div className="subcon1" style={handleclickonbutton1(hamburger)}>
          <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
        </div>
        <div className="subcon2" style={handleclickonbutton(hamburger)}>
          <UserNavbar
            hamburger={hamburger}
            sethamburger={sethamburger}
            isRightMenu={isRightMenu}
            handelRightMenuShow={handelRightMenuShow}
            handelShow={handelShow}
            isSearchShow={isSearchShow}
            handleScreenEnter={handleScreenEnter}
            handleScreenExit={handleScreenExit}
            fullScreen={fullScreen}
          />
        </div>
      </div>
      {status === "NEW" && <JournalConfiguration />}
    </>
  );
};
export default Configure;
